import React, { useEffect, useRef } from "react";
import { useFormik } from "formik";
import {
  InvoiceFilterFields,
  InvoiceFilterFieldsPayload,
} from "./InvoiceFilter.fields";
import { ToggleButtonGroup } from "../CustomButtons/ToggleButtonGroup";

interface InvoiceFilterProps {
  activeFilters: InvoiceFilterFieldsPayload | null;
  isOpen: boolean;
  onClose: () => void;
  onApply: (values: InvoiceFilterFieldsPayload) => void;
}

export const InvoiceFilter: React.FC<InvoiceFilterProps> = ({
  activeFilters,
  isOpen,
  onClose,
  onApply,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);

  const initialValues: InvoiceFilterFieldsPayload = {
    ready: null,
    tax: null,
    taxRate: null,
    category: null,
    currency: null,
    read: null,
    flag: null,
    note: null,
    merged: null,
    duplicates: null,
    paid: null,
    hasMatch: null,
    autoCategorised: null,
    expenseClaim: null,
    dataExtraction: null,
  };

  const formik = useFormik({
    initialValues: activeFilters || initialValues,
    onSubmit: (values) => {
      // 1. Process values to handle the "null" strings from HTML selects
      const processedValues = Object.keys(values).reduce((acc, key) => {
        const val = (values as any)[key];
        acc[key] = val === "null" || val === "" ? null : val;
        return acc;
      }, {} as any);

      // 2. SET THE ALERT MESSAGE HERE
      // alert("Selected Filters:\n" + JSON.stringify(processedValues, null, 2));

      // 3. Apply and close
      onApply(processedValues);
      onClose();
    },
    // enableReinitialize: true,
  });

  /* CLOSE ON OUTSIDE CLICK */
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  useEffect(() => {
  if (isOpen) {
    formik.resetForm({ values: activeFilters || initialValues });
  }
}, [isOpen]);

  if (!isOpen) return null;
  

  return (
    <div className="overlay">
      <div
        className="popup-container"
        ref={popupRef}
        style={{
          width: "600px",
          display: "flex",
          flexDirection: "column",
          maxHeight: "80vh",
          minHeight: "60vh",
        }}
      >
        <p className="section-title" style={{ flexShrink: 0 }}>
          FILTER INVOICES
        </p>

        <form
          onSubmit={formik.handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            overflow: "hidden",
          }}
        >
          <div style={{ overflowY: "auto", paddingRight: "10px", flexGrow: 1 }}>
            {InvoiceFilterFields.map((field) => (
              <div
                key={field.key}
                style={{
                  marginBottom: "5px",
                  // background: "#f9f9f9",
                  padding: "5px",
                  borderRadius: "5px",
                  display: "flex",
                  alignItems: "center",
                  // justifyContent: "space-between",
                  gap: "5px",
                }}
              >
                <label
                  style={{
                    fontSize: "var(--font-size-sm)",
                    fontWeight: "bold",
                    color: "#666",
                    minWidth: "120px", // control label width
                  }}
                >
                  {field.label}
                </label>

                <ToggleButtonGroup
                  disabled={field.disabled}
                  options={field.options}
                  selectedValue={
                    formik.values[field.key as keyof InvoiceFilterFieldsPayload]
                  }
                  onChange={(val) => formik.setFieldValue(field.key, val)}
                />
              </div>
            ))}
          </div>

          <div
            className="footer-actions"
            style={{
              marginTop: "10px",
              borderTop: "1px solid #eee",
              paddingTop: "15px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span
              className="reset-btn"
              style={{ cursor: "pointer", color: "#888", fontSize: "var(--font-size-base)" }}
              onClick={() => {formik.resetForm({ values: initialValues });
              onApply(initialValues);
            }}
              
            >
              Reset
            </span>
            <button type="submit" className="apply-btn">
              Apply Filters
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
